export enum AUTH_ACTION_STATUS_TYPE {
    loading = 'loading',
    ready = 'ready',
    success = 'success',
    error = 'error',
}
